import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import FileBase64 from 'react-file-base64';
import $ from 'jquery';
import Loader from '../../Loader';
import StaffPage from '../../views/StaffPage/';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
class EditEmployee extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			cid : '',
			design : [],
			depart : [],
			types : [],
			posts : [],
			sta : [],
			clas: [],
			empcode : '',
			joindate : '',
			dept : '',
			desig  : '',
			quali : '',
			user : '',
			ename : '',
			dob : '',
			gender : '',
			presentaddr : '',
			permanentaddr : '',
			city : '',
			pincode : '',
			country : '',
			state : '',
			mobile : '',
			phone : '',
			email : '',
			files : [],
			_message : '',
			alertClass :'',
			region : '',
			_redirect : false,
			employees : [],
			classs : [],
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onBack = this.onBack.bind(this);
		this.handleClassChange = this.handleClassChange.bind(this);
	}
	
	handleClassChange(value) {

		this.setState({ classs: value });
	}
	
	//base64 photo
	getFiles(files){
		this.setState({ files: files })
	}
	
	onBack(e){
		
		this.setState({_redirect : true});
	}
	
	onClick(e){
		
		document.getElementById("empform").reset();
	}
	
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
	}
	
	onSubmit(e){
		e.preventDefault();
		 $("#showLoader").show();
		PostData('employee/edit',this.state).then((result) => {
			 $("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == '1' ){
				this.setState({
					_redirect : true
				});
				// document.getElementById("empform").reset();
				this.getdata();
			}
			else{
		
				this.setState({
					_message:'Invalid Key',
					alertClass:'alert alert-danger'
				});
			}
		});
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getclass();
		this.getdepartment();
		this.getdesignation();
		this.getusertype();
		this.getcountry();
		this.getstate();
		this.getdata();
		this.getemployees();
	}
	
	/** get Class **/
	getclass() {

		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					clas: responseJson
				});
			}
		});
	}

	getemployees(){
		$("#showLoader").show();
		GetData('employee/getemployee').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					employees : responseJson
				});
			}
		});
	}
	
	/** get Department **/
	getdepartment(){
		
		GetData('department/getdepartment').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					depart : responseJson
				});
			}
		});
	}
	
	/** get Designation **/
	getdesignation(){
		
		GetData('designation/getdesignation').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					design : responseJson
				});
			}
		});
	}
	
	/** get usertype **/
	getusertype(){
		
		GetData('usertype/getusertype').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					types : responseJson
				});
			}
		});
	}
	
	/** get country **/
	getcountry(){
		
		GetData('home/getcountry').then((result) => {
			let res = result;
			if(res){
				this.setState({posts:res,cid : res[0]['id']});
			}
		});
	}
	
	/** get state **/
	getstate(){
		
		GetData('home/getstate').then((result) => {
			let res = result;
			if(res){
				this.setState({sta:res});
			}
		});
	}
	
	getclsname(cls){
		var d = this.state.clas;
		var clas = '';
		var index = d.findIndex(function(obj){
			return(obj.id == cls);
		});
		if(index > -1){
			clas = d[index]['class'];
		}
		return clas;
	}
	
	// Get Employee By id
	getdata(){
		$("#showLoader").show();
		GetData('employee/getempbyid/'+this.props.match.params.id).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if(res){
				this.setState({
					empcode : res[0]['empcode'],
					joindate : res[0]['joindate'],
					dept : res[0]['department'],
					desig : res[0]['designation'],
					quali: res[0]['qualification'],
					user : res[0]['usertype'],
					ename : res[0]['empname'],
					dob : res[0]['dob'],
					gender : res[0]['gender'],
					presentaddr : res[0]['presentaddress'],
					permanentaddr : res[0]['permanentaddress'],
					city : res[0]['city'],
					pincode : res[0]['pincode'],
					country : res[0]['country'],
					region : res[0]['state'],
					mobile : res[0]['mobile'],
					phone : res[0]['phone'],
					fathername : res[0]['fatherspouse'],
					fathermobile : res[0]['fathermob'],
					aadharno : res[0]['aadhar'],
					panno : res[0]['panno'],
					pfno : res[0]['pfno'],
					esino : res[0]['esino'],
					reference : res[0]['reference'],
					category : res[0]['category'],
					url : res[0]['photo'],
				});
				
				var clss = [];
				var clsList = res[0]['classes'].split(',');
				for(var i=0;i<clsList.length;i++){
					var label = this.getclsname(clsList[i]);
					clss.push({value : clsList[i], label : label})
				}
				
				this.setState({classs : clss});
			}
			
		});
	}
	
	selectCountry (val) {
		this.setState({ country: val });
	}
 
	selectRegion (val) {
		this.setState({ region: val });
	}
	
  render() {
	  
	
	/** match id to update **/
	this.state.id = this.props.match.params.id;
	
	if(this.state._redirect){
		  
		return (<Redirect to='/employee/list' />);
	}
	
	  // const { country, region } = this.state;
	  
	  var dept = this.state.depart;
	  var desi = this.state.design;
	  var utype = this.state.types;
	  var items = this.state.posts;
	  var stat = this.state.sta;
	  
	  this.gen = [
		{value : '', name : 'Select Gender'},
		{value : 'Male', name : 'Male'},
		{value : 'Female', name : 'Female'}
	  ];
	  
		var clss = [];
		this.state.clas.map(function (e, key) {
			clss.push(
				{ value: e.id, label: e.class }
			);
		});
		
    return (
		<div>
		  <StaffPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				  <Col md="12">
					<Card>
					  <form action="" method="post" role="form" id="empform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader>
							<strong>Edit Employee</strong>
							<span className="pull-right">
								<Button outline color="primary" onClick={this.onBack}>Back to Employee List</Button>
							</span>
						</CardHeader>
						<CardBody>
						<h5>Employee Details</h5><hr className="line"></hr>
							<Row>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Employee Code <span className="text-danger">*</span></Label>
								  <Input type="text" name="empcode" required onChange={this.onChange} value={this.state.empcode} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Joining Date</Label>
								  <Input type="date" name="joindate" onChange={this.onChange} value={this.state.joindate} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Department</Label>
								  <select name="dept" onChange={this.onChange} className="form-control" value={this.state.dept}>
									<option value="">Select Department</option>
									{
										dept.map(function (item) {
											return <option value={item.id }>{item.department}</option>;
										})
									}
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Designation</Label>
								  <select name="desig" onChange={this.onChange} className="form-control" value={this.state.desig}>
									<option value="">Select Designation</option>
									{
										desi.map(function (item) {
											return <option value={item.id }>{item.designation}</option>;
										})
									}
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Qualification</Label>
								  <Input type="text" name="quali" onChange={this.onChange} value={this.state.quali} />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
									<Label htmlFor="name">Classes</Label>
									<Select value={this.state.classs} id="classs" onChange={this.handleClassChange} multi options={clss} />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">User Type <span className="text-danger">*</span></Label>
								  <select name="user" onChange={this.onChange} className="form-control" required value={this.state.user}>
									<option value="">Select UserType</option>
									{
										utype.map(function (item) {
											return <option value={item.id }>{item.usertype}</option>;
										})
									}
								  </select>
								</FormGroup>
							  </Col>
								<Col md="3">
									<FormGroup>
										<Label htmlFor="name">Category</Label>
										<select name="category" className="form-control" onChange={this.onChange} value={this.state.category}>
											<option value="">Select Category</option>
											<option value="Nursery">Nursery</option>
											<option value="Pre-Primary">Pre-Primary</option>
											<option value="Primary">Primary</option>
											<option value="Middle">Middle</option>
											<option value="High">High</option>
											<option value="Senior Secondary">Senior Secondary</option>
										</select>
									</FormGroup>
								</Col>
							</Row>
							<h5>Personal Details</h5><hr className="line"></hr>
							<Row>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Employee Name <span className="text-danger">*</span></Label>
								  <Input type="text" name="ename" required onChange={this.onChange} value={this.state.ename} />
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Date of Birth</Label>
								  <Input type="date" name="dob" onChange={this.onChange} value={this.state.dob} />
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Gender <span className="text-danger">*</span></Label>
								  <select name="gender" className="form-control" onChange={this.onChange} required value={this.state.gender}>
									{this.gen.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}		
								  </select>
								</FormGroup>
							  </Col>
								<Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Father/Spouse Name</Label>
								  <Input type="text" name="fathername" onChange={this.onChange} value={this.state.fathername} />
								</FormGroup>
							  </Col>
								<Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Father/Spouse Mobile</Label>
								  <Input type="text" name="fathermobile" onChange={this.onChange} value={this.state.fathermobile} />
								</FormGroup>
							  </Col>
							</Row>
							<h5>Contact Details</h5><hr className="line"></hr>
							<Row>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Present Address</Label>
								  <Input type="textarea" name="presentaddr" onChange={this.onChange} value={this.state.presentaddr} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Permanent Address </Label>
								  <Input type="textarea" name="permanentaddr" onChange={this.onChange} value={this.state.permanentaddr} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">City</Label>
								  <Input type="text" name="city" onChange={this.onChange} value={this.state.city}/>
								</FormGroup>
							  </Col>
							   <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Pincode </Label>
								  <Input type="number" name="pincode" onChange={this.onChange} value={this.state.pincode}/>
								</FormGroup>
							  </Col>
							   <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Country</Label>
								  <CountryDropdown value={this.state.country} onChange={(val) => this.selectCountry(val)} id="con" />
								</FormGroup>
							  </Col>
							   <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">State</Label>
								  <RegionDropdown country={this.state.country} value={this.state.region} onChange={(val) => this.selectRegion(val)} id="con" />
								</FormGroup>
							  </Col>
							   <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Mobile</Label>
								  <Input type="number" name="mobile" onChange={this.onChange} value={this.state.mobile}/>
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Phone</Label>
								  <Input type="number" name="phone" onChange={this.onChange} value={this.state.phone}/>
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Email </Label>
								  <Input type="email" name="email" onChange={this.onChange} value={this.state.email}/>
								</FormGroup>
							  </Col>
							  <Col md="3">
								<Card>
									<CardBody>
										<img src={this.state.url} id="studphoto" />
									</CardBody>
								</Card>
							  </Col>
							  <Col md="3">
								<FormGroup>
									<FileBase64 onDone={ this.getFiles.bind(this) }  />
								</FormGroup>
							  </Col>
							</Row>
							<h5>Other Details</h5><hr className="line"></hr>
							<Row>
								<Col md={4}>
									<FormGroup>
										<Label htmlFor="name">Aadhar No </Label>
										<Input type="number" name="aadhar" onChange={this.onChange} value={this.state.aadhar} />
									</FormGroup>
								</Col>
								<Col md={4}>
									<FormGroup>
										<Label htmlFor="name">Pan No </Label>
										<Input type="number" name="panno" onChange={this.onChange} value={this.state.panno} />
									</FormGroup>
								</Col>
								<Col md={4}>
									<FormGroup>
										<Label htmlFor="name">PF No </Label>
										<Input type="number" name="pfno" onChange={this.onChange} value={this.state.pfno} />
									</FormGroup>
								</Col>
								<Col md={4}>
									<FormGroup>
										<Label htmlFor="name">ESI No </Label>
										<Input type="number" name="esino" onChange={this.onChange} value={this.state.esino} />
									</FormGroup>
								</Col>
								<Col md={4}>
									<FormGroup>
										<Label htmlFor="name">Refered Staff </Label>
										<Input type="text" list="slist" name="reference" onChange={this.onChange} value={this.state.reference} />
										<datalist id="slist">
											{this.state.employees.map((item,i)=>
													<option value={item.empname}></option>
												)}
										</datalist>
									</FormGroup>
								</Col>
							</Row>
						</CardBody>
						<CardFooter>
						 <Button type="submit" size="md" color="primary" className="btn-right"><i className="fa fa-dot-circle-o"></i> Update</Button>
						</CardFooter>
					  </form>
					</Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default EditEmployee;


// WEBPACK FOOTER //
// ./src/employee/Employee/EditEmployee.js